/*
 * @Description:
 * @Date: 2022-03-10 10:55:33
 */
import { route } from './src/router/index';

const name = 'home';

export { name, route };
